import { theme } from '../constants/defaults';
import htmlEscape from '../utils/htmlEscape';
import { normalizeProduct } from '../utils/product';
import searchResultsProductTemplate from './searchResultsProductTemplate';
import loadingTemplate from './loadingTemplate';

function renderHeader(products, isLoading) {
  if (products.length === 0) {
    return '';
  }

  return `<div class="predictive-search-title">
      <h3 id="predictive-search" class="predictive-search-title__content">
        ${theme.strings.products}
      </h3>
      <span class="predictive-search-title__loading-spinner">
        ${isLoading ? '<span class= "icon-predictive-search-spinner" ></span>' : ''}
      </span>
    </div>`;
}

function loadingState() {
  return `<div class="predictive-search">
    ${loadingTemplate()}
  </div>`;
}

function renderViewAll(searchQuery) {
  return `<button type="submit" class="predictive-search-view-all__button" tabindex="-1">
    ${theme.strings.searchFor}
    <span class="predictive-search-view-all__query"> &ldquo;
      ${htmlEscape(searchQuery)}
      &rdquo;
    </span>
  </button>`;
}

function renderProducts(products, searchQuery) {
  const resultsCount = products.length;

  const productsList = products.map((product, index) => {
    const productObject = normalizeProduct(product);
    return searchResultsProductTemplate(productObject, index, resultsCount);
  });

  return `<ul id="predictive-search-results" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">
    ${productsList.join('')}
    <li id="search-all" class="predictive-search-view-all" role="option" data-search-result>
      ${renderViewAll(searchQuery)}
    </li>
  </ul>`;
}

function renderResults(products, isLoading, searchQuery) {
  return `<div class="predictive-search">
    ${renderHeader(products, isLoading)}
    ${renderProducts(products, searchQuery)}
  </div>`;
}

export const numberOfResultsTemplateFct = data => {
  if (data.products.length === 1) {
    return theme.strings.one_result_found;
  }

  return theme.strings.number_of_results_found.replace('[results_count]', data.products.length);
};

export const searchResultsTemplate = data => {
  const products = data.products || [];
  const { isLoading } = data;
  const searchQuery = data.searchQuery || '';

  if (isLoading && products.length === 0) {
    return loadingState();
  }

  return renderResults(products, isLoading, searchQuery);
};

// (a11y) This function will be used by the Predictive Search Component
// to announce that it's loading results
export const loadingResultsMessageTemplateFct = () => {
  return theme.strings.loading;
};
